import Draggable from 'vuedraggable'
import { createGroupFields } from './utils'
import './style/drag-item.scss'

const CLASS = 'kye-query-drag-group'

const PROPS = {
  // formFields: Object,
}

export default {
  props: PROPS,

  data () {
    return {
      formFields: [],
      dragOptions: {
        draggable: '.item',
        handle: '.item',
        animation: 150,
        filter: '.undraggable',
        ghostClass: 'kye-ghost'
      },
      groupFields: [],
      checkAll: true,
      indeterminate: false,
      activeKey: ''
    }
  },
  methods: {
    init (fields = []) {
      if (!fields || !fields.length) return
      this.formFields = fields
      this.groupFields = createGroupFields(fields)
      this.reset()
    },
    reset () {
      const data = this.groupFields
      data.forEach(item => {
        item.$show = !!item.show
        if (item.fields && item.fields.length) {
          item.fields.forEach(child => {
            child.$show = !!child.show
          })
          item.indeterminate = item.fields.some(v => !v.show) && item.fields.some(v => v.show)
        }
      })

      this.setCheckAll()
    },
    handleCheck (val, item, data) {
      const show = item.indeterminate ? true : !!val
      item.$show = show
      if (item && item.fields) {
        item.fields.forEach(child => {
          if (!child.required) {
            child.$show = show
          }
        })
        item.indeterminate = false
      }

      this.setCheckAll()
    },
    handleChildCheck (val, child, item, data) {
      child.$show = !!val
      if (item && item.fields) {
        item.indeterminate = item.fields.some(v => !v.$show)
        item.$show = item.fields.some(v => v.$show)
      }

      this.setCheckAll()
    },
    // 全选
    handleCheckAll (val) {
      const data = this.groupFields
      const show = this.indeterminate ? true : !!val
      data.forEach(item => {
        // 必填项不受全选影响
        if (!item.required) {
          item.$show = show
        }
        item.fields.forEach(child => {
          if (!child.required) {
            child.$show = show
          }
        })
        item.indeterminate = false
      })
      this.setCheckAll()
    },
    setCheckAll () {
      const data = this.groupFields
      this.checkAll = data.some(v => v.$show)
      this.indeterminate = data.some(v => !v.$show || v.indeterminate)
    },
    handleNextQuery (e) {
      let currentValue = this.$refs.input && this.$refs.input.currentValue
      if (e.keyCode === 13 && currentValue) {
        this.inputChange(currentValue)
      }
    },
    inputChange (val) {
      val = val.trim()
      if (!val) {
        this.activeKey = ''
        return
      }

      let flatArr = []
      this.groupFields.forEach((v, index) => {
        flatArr.push({ ...v })
        if (v.fields && v.fields.length) {
          v.fields.forEach(child => {
            flatArr.push({
              ...child
            })
          })
        }
      })

      // 如果匹配在末位，需重置匹配
      // 实时搜索，需重置匹配
      let last = flatArr.map(v => ({ ...v })).reverse().find(v => v.label.includes(val))
      if (last && last.key === this.activeKey) {
        this.activeKey = ''
      }

      // 模糊匹配
      const activeIndex = flatArr.findIndex(item => this.activeKey === item.key)
      const num = flatArr.findIndex((v, index) => v.label.includes(val) && activeIndex < index)

      if (num > -1) {
        this.activeKey = flatArr[num].key
        const liDom = this.$refs.draggableWrapper.querySelector('ul div.item') // 最小容器
        const height = liDom.getBoundingClientRect().height // 获取一项 高度
        this.$refs.draggableWrapper.scrollTo({ top: num * height, behavior: 'smooth' }) // 滚动到对应高度
      } else {
        this.activeKey = ''
      }
    },
    clickExpand (item) {
      item.$expand = !item.$expand
    },
    draggableEnd () {
      const flatArr = this.groupFields.reduce((prev, cur) => {
        if (cur.fields && cur.fields.length) {
          cur.fields.forEach(child => {
            prev.push({
              ...child
            })
          })
        }
        return prev
      }, [])
      this.formFields.forEach(item => {
        item._groupIndex = flatArr.findIndex(v => item.propertyName === v.propertyName)
      })
      this.formFields.sort((a, b) => a._groupIndex - b._groupIndex)
    },
    // 禁用拖拽 require 相关的项
    checkMove(evt) {
      const { relatedContext, draggedContext } = evt
      // 禁止拖拽到 required相关的项
      if (relatedContext.element.required || draggedContext.element.required) {
        return false
      }
      return true
    }
  },
  render () {
    const renderInput = () => {
      return (
        <el-input
          ref="input"
          style="margin-top:4px;"
          placeholder="输入关键字后可定位到指定项"
          nativeOnKeypress={this.handleNextQuery}
          onInput={val => this.inputChange(val)}>
          <el-button slot="append" onClick={this.handleNextQuery}>下一个</el-button>
        </el-input>
      )
    }

    const renderHeader = () => {
      return (
        <div class="header-title">
          <el-checkbox
            value={this.checkAll}
            indeterminate={this.indeterminate}
            onChange={val => this.handleCheckAll(val)}>全选
          </el-checkbox>
          <span>字段名(上下拖动排序)</span>
        </div>
      )
    }

    const renderExpandIcon = (item) => {
      return (
          <i
          style="font-size: 14px;position: absolute; top: 4px; left: 0px;color: #c0c4cc;"
          class={item.$expand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'}
          onClick={_ => this.clickExpand(item)}>
        </i>
      )
    }

    const renderChildren = (item, index, data) => {
      return (
        item.$expand &&
        <Draggable
          key={index}
          ref="draggable"
          tag="div"
          style="flex:1;"
          list={item.fields}
          onEnd={this.draggableEnd}
          options={this.dragOptions}
          move={evt => this.checkMove(evt)}
          >
            {
              item.fields.map(child => {
                return (
                  <div
                    class={{ 'item': true, 'is-active': this.activeKey === child.key, 'undraggable': child.required }}
                    key={child.propertyName}>
                    <el-checkbox
                      value={child.$show}
                      disabled={child.required}
                      onChange={val => this.handleChildCheck(val, child, item, data)}>
                      {child.label}
                    </el-checkbox>
                  </div>
                )
              })
            }
        </Draggable>
      )
    }

    const renderDragContent = (data) => {
      return (
        <div ref="draggableWrapper" class="tabs-content" style="display:flex;">
          <Draggable
            key="dragKey"
            ref="draggable"
            tag="ul"
            style="flex:1;"
            list={data}
            options={this.dragOptions}
            move={evt => this.checkMove(evt)}>
              {
                data.map((item, index) => {
                  return (
                    <li
                      class={{ 'item': true, 'is-active': this.activeKey === item.key, 'undraggable': true }}
                      key={item.key}>
                      { renderExpandIcon(item) }
                      <el-checkbox
                        value={item.$show}
                        indeterminate={item.indeterminate}
                        onChange={val => this.handleCheck(val, item, data)}>
                        { item.label }
                      </el-checkbox>
                      { renderChildren(item, index, data) }
                    </li>
                  )
                })
              }
          </Draggable>
        </div>
      )
    }

    return (
      <div class={CLASS}>
        { renderInput() }
        { renderHeader() }
        { renderDragContent(this.groupFields) }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/query-form-group/query-group-drag.js